import { Typography } from '@material-ui/core';
import AssembleiaEditModal, { IAssembleiaEditModal } from 'components/AssembleiaEditModal/AssembleiaEditModal';
import CategoriaDocumentosModal from 'components/CategoriaDocumentosModal/CategoriaDocumentosModal';
import LayoutContext from 'components/Layout/LayoutContext';
import PrivateContainer from 'components/PrivateContainer';
import { ITopBarMenuItem } from 'components/TopBar/TopBarMenuItem';
import { ListaEventoRequest } from 'models/ListaEventoRequest';
import React, { Fragment, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { assembleiasAssessorLoadProdutosPorTipo, assembleiasAssessorLoadTipos, assembleiasAssessorLoadTiposProduto } from 'store/modules/AssembleiasAssessorActions';
import { modalsActionsOpen } from 'store/modules/ModalsActions';
import { getUniqueKey } from 'utils/KeyUtils';
import Filtros from './Filtros';
import useStyle from './style';
import Tabela from './Tabela';

export default function HomeAssessor() {
  const { t } = useTranslation();
  const classes = useStyle();
  const [filters, setFilters] = useState<Partial<ListaEventoRequest>>();
  const [hasDateError, setDateErrorFlag] = useState<boolean>(false);
  const dispatch = useDispatch();
  const { setPageMenuItems } = useContext(LayoutContext);

  useEffect(() => {
    dispatch(assembleiasAssessorLoadTipos())
    dispatch(assembleiasAssessorLoadTiposProduto())
  }, [dispatch])

  useEffect(() => {
    if (filters && filters.tipoProduto) {
      dispatch(assembleiasAssessorLoadProdutosPorTipo(filters.tipoProduto));
    }
  }, [dispatch, filters])

  const criarAssembleia = useCallback(() => {
    const modalKey = getUniqueKey();
    dispatch(
      modalsActionsOpen(
        AssembleiaEditModal,
        {
          genericProps: {
            key: modalKey
          }
        } as IAssembleiaEditModal,
        modalKey
      )
    );
  }, [dispatch]);

  const criarCategoria = useCallback(() => {
    const modalKey = getUniqueKey();
    dispatch(
      modalsActionsOpen(
        CategoriaDocumentosModal,
        {
          genericProps: {
            key: modalKey
          }
        } as IAssembleiaEditModal,
        modalKey
      )
    );
  }, [dispatch]);

  const subMenu = useMemo<ITopBarMenuItem[]>(() => {

    const menus: ITopBarMenuItem[] = [];

    menus.push({
      label: t(`SubMenus.cadastrarAssembleia`),
      onClick: () => criarAssembleia()
    })

    menus.push({
      label: t(`SubMenus.cadastrarCategoria`),
      onClick: () => criarCategoria()
    })

    return menus;

  }, [t, criarAssembleia, criarCategoria])

  useEffect(() => {
    setPageMenuItems(subMenu);
    return () => setPageMenuItems();
  }, [subMenu, setPageMenuItems]);

  return (
    <PrivateContainer
      headerClassName={classes.header}
      header={
        <Fragment>
          <Typography component="p" className={classes.subtitle}>
            {t('TelaInicialAssessor.subtitle')}
          </Typography>
        </Fragment>
      }
    >
      <Filtros onChangeFilter={setFilters} onValidateDate={setDateErrorFlag} />
      <Tabela filters={filters} hasDateError={hasDateError} />
    </PrivateContainer>
  );
}
